import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ButtonDeprecated, { BUTTON_THEME_GREEN } from 'client/components/ButtonDeprecated';
import log from 'client/lib/log';
import branch from 'client/core/branch';
import {
  APPLICATION_FORM_TYPE_RENTER_PREQUAL,
} from 'common/householdApplication/applicationFormFields';

import updateRenterProfileAction from 'client/actions/Household/updateRenterProfile';
import redirectToApplicationFormAction from 'client/actions/Household/redirectToApplicationForm';

import analytics from 'client/analytics';
import {
  ANALYTICS_EVENT_PREQUAL_CTA_CLICK,
} from 'client/analytics/eventList';

@branch({
  currentUserId: ['currentUser', 'id'],
})
class SrListingPrequalCta extends Component {
  static propTypes = {
    currentUserId: PropTypes.number.isRequired,
    listing: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  _onStartPrequalButtonClick = () => {
    const { currentUserId, listing, dispatch } = this.props;

    analytics.track(ANALYTICS_EVENT_PREQUAL_CTA_CLICK);

    dispatch(updateRenterProfileAction, {
      userId: currentUserId,
      updates: {
        hasStartedPrequal: true,
      },
    })
      .then(() => {
        return dispatch(redirectToApplicationFormAction, {
          formType: APPLICATION_FORM_TYPE_RENTER_PREQUAL,
          prequalListingId: parseInt(listing.id, 10),
          shouldRestart: true,
          shouldRequestTourPrompt: true,
        });
      })
      .catch((error) => {
        log.error(error);
      });
  }

  render() {
    return (
      <div className='SrListingPrequalCta'>
        <div className='header'>
          <span>
            can you rent this home?
          </span>
        </div>
        <div className='text'>
          <span>
            Save time searching and find out which  homes you’re eligible to rent.
          </span>
        </div>
        <ButtonDeprecated
          theme={BUTTON_THEME_GREEN}
          onClick={this._onStartPrequalButtonClick}
        >
          <span className='buttonContent'>
            start the quiz
            <span className='arrow'>
              →
            </span>
          </span>
        </ButtonDeprecated>
      </div>
    );
  }
}

SrListingPrequalCta.displayName = 'SrListingPrequalCta';

export default SrListingPrequalCta;
